import { AllowedUser, InvitedUser } from "../user/user.model";
import { Tag } from "../utils.model";

export class Plant {

  constructor(
    public name? : string,
    public country? : string,
    public type? : string,
    public creationDate? : Date,
    public ownerId? : string,
    public ownerEmail? : string,
    public status? : string,
    public zipCode? : number,
    public address? : string,
    public offset? : string,
    public allowedUsers? : AllowedUser[],
    public invitedUsers? : InvitedUser[],
    public tags? : Tag[],
    public internalId? : string,
    public establishment? : string,
    public floor? : number,
    public companyName?: string,
    public id? : string){}

}

export class SearchPlant {

  constructor(
    public name? : string,
    public id? : string){}

}

export class OwnerAuthorization {
  constructor(
    public password : string,
    public shouldCurrentUserRightsBeRemoved? : boolean){}
}

/* export enum PlantType {
  HOTEL = 'hotel',
  HOUSE = 'house',
  OFFICE = 'office',
  HOSPITAL = 'hospital'
} */

export enum AddPlantFromDeviceType {
  NONE = '',
  ADD = 'add',
  EDIT = 'edit'
}
